import axios from 'axios'
import api from '@/store/api';
import {tratamente} from '../tratamente';
import router from '@/router';

function generateNewStage (id) {
  return {
    id,
    title: '',
    treatments: [
      // {
      //   id: `${id}t1`,
      //   name: '',
      //   price: '',
      //   teeth: [],
      //   notes: '',
      //   medic: ''
      // }
    ]
  }
}

function generateNewPlan () {
  return {
    title: '',
    description: '',
    stages: [],
    patientCare: [],
    conditiiComerciale: {
      content: '',
      value: '',
      options: [
        {
          date: '',
          percentage: '100'
        },
        {
          date: '',
          percentage: ''
        },
        {
          date: '',
          percentage: ''
        }
      ]
    },
    payments: []
  }
}

export const state = {
  newPlan: {
    title: '',
    description: '',
    stages: [],
    patientCare: [],
    conditiiComerciale: {
      content: 'Continut conditii comerciale tip 1',
      value: 'Tip 1',
      options: [
        {
          date: '',
          percentage: '100'
        },
        {
          date: '',
          percentage: ''
        },
        {
          date: '',
          percentage: ''
        }
      ]
    },
    payments: []
  },
  isModal: false,
  conditiiComerciale: [
    {name: 'Tip 1', id: 1, content: 'Continut conditii comerciale tip 1'},
    {name: 'Tip 2', id: 2, content: 'Continut conditii comerciale tip 2'},
    {name: 'Tip 3', id: 3, content: 'Continut conditii comerciale tip 3'}
  ],
  plans: [],
  plan: {},
  searchTratament: '',
  selectedPatientCare: {}
}

export const mutations = {
  RESET_NEW_PLAN (state) {
    state.newPlan = generateNewPlan();
    console.log(state.newPlan);
  },
  UPDATE_TREATMENT (state, treatment) {
    state.plan.stages.forEach((stage) => {
      stage.treatments.forEach((t, idx) => {
        if (treatment.id === t.id) {
          stage.treatments[idx] = treatment;
        }
      })
    })
  },
  UPDATE_STAGES_ORDER (state, { data: newOrder }) {
    const updatedStagesOrder = [];
    newOrder.forEach(({id}) => {
      const stage = state.newPlan.stages.find((stage) => stage.id === id);
      updatedStagesOrder.push(stage);
    })
    state.newPlan.stages = updatedStagesOrder;
  },
  UPDATE_TREATMENTS_ORDER (state, { stageId, data }) {
    const updatedTreatmentsData = [];
    const stage = state.newPlan.stages.find((stage) => stage.id === stageId);
    data.forEach((t, idx) => {
      const treatment = stage.treatments.find((treatment) => treatment.id === t.id);
      updatedTreatmentsData.push(treatment);
    })
    stage.treatments = updatedTreatmentsData;
  },
  UPDATE_CONDITII_COMERCIALE (state, data) {
    const index = state.conditiiComerciale.findIndex(item => item.name === data.value);
    state.conditiiComerciale[index].content = data.content;
  },
  SET_PT (state, {name, data}) {
    state[name] = data;
  },
  SET_CONDITII_COMERCIALE_VALUE (state, value) {
    state.newPlan.conditiiComerciale.value = value;
  },
  SET_CONDITII_COMERCIALE_CONTENT (state, value) {
    const index = state.conditiiComerciale.findIndex(item => item.name === value);
    state.newPlan.conditiiComerciale.content = state.conditiiComerciale[index].content;
  },
  SET_NEW_PLAN_FIELD (state, { name, value }) {
    state.newPlan[name] = value;
  },
  SET_NEW_PLAN_STAGE_FIELD (state, { stageId, name, value }) {
    const index = state.newPlan.stages.findIndex(o => o.id === stageId);
    state.newPlan.stages[index][name] = value;
  },
  SEARCH_TREATMENT (state, value) {
    state.searchTratament = value;
  },
  SET_TREATMENT_FIELD (state, { name, value, treatment }) {
    treatment[name] = value;
  },
  DELETE_TREATMENT_FIELD (state, { name, treatment }) {
    delete treatment[name];
  },
  ADD_NEW_TREATMENT (state, { stageId, treatment }) {
    const index = state.newPlan.stages.findIndex(o => o.id === stageId);
    const stage = state.newPlan.stages[index];
    treatment.id = `${stage.id}t${stage.treatments.length + 1}`;
    state.newPlan.stages[index].treatments.push(treatment);
  },
  DELETE_TREATMENT (state, { stageId, treatmentId }) {
    const index = state.newPlan.stages.findIndex(o => o.id === stageId);
    const idx = state.newPlan.stages[index].treatments.findIndex(o => o.id === treatmentId);
    state.newPlan.stages[index].treatments.splice(idx, 1);
  },
  ADD_NEW_STAGE (state) {
    const id = `s${state.newPlan.stages.length + 1}`;
    state.newPlan.stages.push(generateNewStage(id));
  },
  DELETE_STAGE (state, id) {
    const index = state.newPlan.stages.findIndex(o => o.id === id);
    state.newPlan.stages.splice(index, 1);
  },
  ADD_DINTE_TO_TREATMENT (state, { indexDinte, treatment, done = false }) {
    treatment.teeth.push({ index: indexDinte, done });
  },
  REMOVE_DINTE_TO_TREATMENT (state, { indexDinte, treatment }) {
    const index = treatment.teeth.findIndex(o => o.index === indexDinte);
    treatment.teeth.splice(index, 1);
  },
  SAVE_NEW_PATIENT_CARE (state, data) {
    const id = state.newPlan.patientCare.length + 1;
    state.newPlan.patientCare.push({ id, ...data });
    state.isModal = false;
  },
  UPDATE_PATIENT_CARE (state, data) {
    const index = state.newPlan.patientCare
      .findIndex(o => o.id === data.id);
    state.newPlan.patientCare[index] = data;
    state.isModal = false;
  },
  DELETE_PATIENT_CARE (state, data) {
    const index = state.newPlan.patientCare
      .findIndex(o => o.id === data.id);
    state.newPlan.patientCare.splice(index, 1);
    state.isModal = false;
  },
  SAVE_NEW_PLAN (state) {
    state.plans.push({...state.newPlan});
    state.newPlan = generateNewPlan();
  },
  SET_EDIT_PLAN (state, data) {
    state.newPlan = data;
  },
  UPDATE_PLAN_PAYMENTS (state, { _id, payments }) {
    const index = state.plans.findIndex(o => o._id === _id);
    state.plans[index].payments.push({ ...payments });
  },
  INITIALIZE_TREATMENT_PLAN_TITLE (state, patient) {
    state.newPlan.title = `PT#${patient.id} ${patient.nume} ${patient.prenume}`;
  }
}

export const actions = {
  async get_planuri_tratament ({ commit }) {
    try {
      const patientId = router.currentRoute.params.id;
      const { data } = await axios.get(`${api.planuriTratament}/${patientId}`);
      commit('SET_PT', { name: 'plans', data });
    } catch (error) {
      commit('SET_ERROR', 'Failed to load treatment plans')
    }
  },
  async get_plan_tratament ({ commit }, { idPlanTratament, isEdit }) {
    try {
      const { data } = await axios.get(`${api.planTratament}/${idPlanTratament}`);
      commit('SET_PT', { name: 'plan', data });
      isEdit && commit('SET_EDIT_PLAN', data);
    } catch (error) {
      commit('SET_ERROR', 'Failed to load treatment plans')
    }
  },
  async save_plan_tratament ({ state, commit }) {
    try {
      const patientId = router.currentRoute.params.id;
      const { data } = await axios.post(`${api.planTratament}/${patientId}`, state.newPlan);
      commit('SAVE_NEW_PLAN', data);
      await router.push(`/pacienti/planuri-tratament/${patientId}`);
    } catch (error) {
      commit('SET_ERROR', 'Failed to save treatment plans')
    }
  },
  async update_plan_tratament ({ state, commit }) {
    try {
      const patientId = router.currentRoute.params.id;
      const { data } = await axios.put(api.planTratament, state.newPlan);
      // todo update plan
      await router.push(`/pacienti/planuri-tratament/${patientId}`);
    } catch (error) {
      commit('SET_ERROR', 'Failed to save treatment plans')
    }
  },
  async save_payment ({ state, commit }, { _id, payment, clbk = () => {} }) {
    try {
      const { data } = await axios.put(`${api.planTratament}/save-payment/${_id}`, payment);
      commit('UPDATE_PLAN_PAYMENTS', {_id, payments: data});
      clbk();
    } catch (error) {
      commit('SET_ERROR', 'Failed to save payment')
    }
  }
}

export const getters = {
  tratamente: state => {
    let results = tratamente.slice();
    if (state.searchTratament) {
      results = tratamente.filter((item) => {
        return item.name?.toLowerCase().startsWith(state.searchTratament.toLowerCase());
      })
    }
    return results
  }
}
